import { createMongoAbility } from "@casl/ability";
import AclService from "../services/AclService";

export const createClassAbility = async classId => {
  const res = await AclService.getClassAcl(classId);
  if (!res) return [];
  return createMongoAbility(res);
};

export const createAbility = async () => {
  const res = await AclService.getAcl();
  if (!res) return [];
  return createMongoAbility(res);
};
